<template>
  <b-row no-gutters align-v="center" style="margin: 0; padding: 12px 6px;">
    <b-col cols="auto" style="padding:2px !important">
      <vs-button @click="stockDetail(params.data)" radius size="small" icon="search" type="gradient"
        v-b-tooltip.hover.bottom="'Stok Detayı'"></vs-button>
    </b-col>
    <b-col cols="auto" style="padding:2px !important">
      <vs-button @click="recete(params.data.stokKodu)" color="success" radius size="small" icon="event_note"
        type="gradient" v-b-tooltip.hover.bottom="'Stok Reçetesi'"></vs-button>
    </b-col>
    <b-col cols="auto" style="padding:2px !important">
      <vs-button @click="getLogRecords(params.data.stokKodu)" color="danger" radius size="small" icon="assignment"
        type="gradient" v-b-tooltip.hover.bottom="'Stok Log Kayıtları'"></vs-button>
    </b-col>
    <b-col cols="auto" style="padding:2px !important">
      <vs-button @click="priceUpdate(params.data)" color="warning" radius size="small" icon="attach_money"
        type="gradient" v-b-tooltip.hover.bottom="'Fiyat Güncelle'"></vs-button>
    </b-col>
    <b-col cols="auto" style="padding:2px !important">
      <vs-button @click="priceLogs(params.data)" color="primary" radius size="small" icon="history"
        type="gradient" v-b-tooltip.hover.bottom="'Fiyat Güncelleme Logları'"></vs-button>
    </b-col>
    <ReceteComponent ref="recetePopup" />
    <LogList :isAktiveLogList="isAktiveLogList" :module="'Stock'" ref="getLogList" />
    <StokListesiFiyatLoglari ref="priceLogPopup" />
  </b-row>
</template>

<script>
import LogList from "../../components/uzum-components/LogList.vue";
import ReceteComponent from "../../components/uzum-components/stoklistesi-components/ReceteComponent.vue";
import StokListesiFiyatLoglari from "../StokListesiFiyatLoglari.vue";
export default {
  components: { ReceteComponent, LogList, StokListesiFiyatLoglari },
  data() {
    return { isAktiveLogList: false }
  },
  methods: {
    getLogRecords(stockNo){
      this.$refs.getLogList.getLogList(stockNo)
    },
    stockDetail(data) {
      this.$root.$emit("getStockListDetail", data);
    },
    priceUpdate(data) {
      this.$root.$emit("getStockPriceUpdate", data);
    },
    priceLogs(data) {
      this.$refs.priceLogPopup.open(data);
    },
    recete(skod) {
      //  alert(skod)
      this.$refs.recetePopup.receteDetay(skod);
    },
  }
};
</script>
